(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("LayoutController", LayoutController);

  /** @ngInject */
  function LayoutController(
    $scope,
    broker,
    LayoutViewModel,
    applicationStore,
    $mdToast,
    $timeout,
    refreshToken,
    sessionData
  ) {
    var vm = this;
    // Get token on app init and set to local storage (from router resolver)
    if (refreshToken) {
      sessionData.setValue(
        sessionData.Keys.ACCESS_TOKEN_KEY,
        refreshToken.accessToken
      );
    }

    vm.layout = new LayoutViewModel();
    vm.smallMenu = localStorage.getItem(sessionData.Keys.SMALL_MENU) === "true";

    init();

    function init() {
      $scope.$on("$destroy", destroy);
      broker.initWebSockets();

      applicationStore.on(
        applicationStore.events.LOADER_CHANGE,
        showHideLoader
      );
      applicationStore.on(
        applicationStore.events.ERROR_STATE_CHANGE,
        showHideError
      );
      applicationStore.on(
        applicationStore.events.TOAST_CHANGE,
        showSimpleToast
      );
    }

    function showHideLoader(_isLoading) {
      vm.layout.isLoading = _isLoading;
    }

    function showHideError(_hasError, _errMsgName, _errMsgDescription) {
      vm.layout.hasError = _hasError;
      vm.layout.errorName = _errMsgName;
      vm.layout.errorDescription = _errMsgDescription;
      $timeout(hideErrorMsg, 10000);
    }

    function hideErrorMsg() {
      vm.layout.hasError = false;
    }

    function showSimpleToast(data) {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent(data)
          .position("bottom right")
          .hideDelay(3000)
      );
    }

    function destroy() {
      if (broker.isConnected()) {
        broker.unsubscribeSocket();
        broker.disconnectSockets();
      }
      vm.layout.destroy();
    }
  }
})();
